import { PrepaymentUserBalance } from '@core/models/prepayment.model';
import { createActionGroup, props } from '@ngrx/store';

import { DoodApiError } from '@shared/interfaces/error.interface';

export const PREPAYMENT_PLUGINS_USER_BALANCE_API_ACTIONS = createActionGroup({
  source: 'Dood/API/Plugins/UserBalance',
  events: {
    'Need to display User Balance': props<{
      shopId: string;
    }>(),
    'Fetching': props<{
      shopId: string;
    }>(),
    'Fetching Success': props<
      PrepaymentUserBalance & {
        shopId: string;
      }
    >(),
    'Fetching Failure': props<{ error: DoodApiError; shopId: string }>(),
  },
});
